import request from '@/utils/request';

const PATH = '/stay/room/price';

export const getStayRoomPrice = () => request({
  url: PATH,
  method: 'get',
});

export const getStayRoomPricePerDay = (roomIdx: any, date: any) => request({
  url: `${PATH}/${roomIdx}/daily`,
  method: 'get',
  params: {
    date,
  },
});

export const saveStayRoomPrice = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});
